<section class="benefits-section">
    <h2 class="benefits-title">
        {{ title }}
    </h2>

    <div class="benefits-list">
        <div class="benefit-row" *ngFor="let item of questions; let i = index; trackBy: trackByItem">
            <div class="benefit-icon">
                <img *ngIf="getBenefitImage(i)" class="benefit-icon__image" [src]="getBenefitImage(i)"
                    alt="Icono beneficio" />
            </div>

            <div class="benefit-item">
                <div class="benefit-title" [innerHTML]="item.title">
                </div>

                <ul class="benefit-list" *ngIf="item.bullets?.length">
                    <li class="benefit-list-item" *ngFor="let bullet of item.bullets; trackBy: trackByBullet">
                        {{ bullet }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>